import {
    FETCH_SUBSCRIPTION,
    FETCH_SUBSCRIPTION_SUCCESS,
    FETCH_SUBSCRIPTION_FAILED,
    EDIT_SUBSCRIPTION
  } from "../store/types";
  
  const INITIAL_STATE = {
    subscriptions: null,
    loading: false,
    error: {
      flag: false,
      msg: null
    }
  }
  
  export const subscriptionreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_SUBSCRIPTION:
        return {
          ...state,
          loading: true
        };
      case FETCH_SUBSCRIPTION_SUCCESS:
        return {
          ...state,
          subscriptions: action.payload,
          loading: false
        };
      case FETCH_SUBSCRIPTION_FAILED:
        return {
          ...state,
          subscriptions: null,
          loading: false,
          error: {
            flag: true,
            msg: action.payload
          }
        };
      case EDIT_SUBSCRIPTION:
        return state;
      default:
        return state;
    }
  };